/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.templatesrpc.TemplateInstantiationService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const instantiateTemplateRpc = {
  serviceName: 'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'instantiateTemplate',
  auth: 'app',
  fingerprint: 'hM7HJwxYT2apn7CVh1dwUN0LIIxqXL4B',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstantiationStatusRpc = {
  serviceName: 'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'getInstantiationStatus',
  auth: 'app',
  fingerprint: 'QIJe6dqwsi1Dp6C6QitBXNrKPlNJ01-G',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listInstantiationRequestsRpc = {
  serviceName: 'com.hubspot.automation.templatesrpc.TemplateInstantiationService',
  rpcName: 'listInstantiationRequests',
  auth: 'app',
  fingerprint: 'sY2kt8fWxgpo6iipdp25f5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};